import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import BasicInput from './fields/BasicInput';
import SimpleCheckbox from './fields/SimpleCheckbox';

class InnerForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
  };

  render() {
    const { handleSubmit, isSubmitting } = this.props;
    return (
      <form className="m-login__form m-form" onSubmit={handleSubmit} autoComplete="off">
        <BasicInput
          {...this.props}
          name="code"
          type="text"
          placeholder="2FA Code"
          autocomplete="one-time-code"
          className="m-login__form-input--last border p-3 mb-2"
          tabIndex="0"
          autoFocus
        />

        <SimpleCheckbox {...this.props} name="use_recovery_code" label="Use recovery code" />

        <div className="m-login__form-action">
          <button
            id="m_login_signin_submit"
            className="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air"
            disabled={isSubmitting}
          >
            Submit
          </button>
        </div>
      </form>
    );
  }
}

const TwoFaForm = withFormik({
  mapPropsToValues: (props) => ({
    code: '',
    use_recovery_code: false,
  }),
  validate: (values, props) => {
    let errors = {};
    if (!values.code) {
      errors.code = 'Required';
    }
    return errors;
  },
  handleSubmit: (values, { props, setSubmitting }) => {
    props.handleSubmit(values);
    setSubmitting(false);
  },
})(InnerForm);

export default TwoFaForm;
